var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"menu",attrs:{"default-active":_vm.$route.path,"router":"","background-color":"#131a2c","unique-opened":true,"collapse":_vm.iscollapse,"collapse-transition":false,"mode":"vertical","text-color":"#fff","active-text-color":"#257bcc"}},[_c('SidebarItem',{attrs:{"data":_vm.menu.menuList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }